<template>
    <div>
        <!-- pc -->
        <el-container v-if="innerWidth > 1023">
            <el-aside width="auto" style="overflow: hidden;">
                <common-aside :innerWidth="innerWidth" :menuData="asideData" @menu-item-clicked="handleMenuItemClick" style="height: 96%;" />
            </el-aside>
            <el-main>
                <CommonTab :equipmentList="equipmentList" :equipment_id="equipment_id" :supplierBrand="supplierBrand"  :brand_id="brand_id" :cityList="cityList" @selectEquipment="selectEquipment" @selectBrand="selectBrand" @selectCity="selectCity" @inputChange="inputChange" @serach="serach"></CommonTab>
                <supplierList :innerWidth="innerWidth"  :supplierList="supplierList" :recommendlist="recommendlist"></supplierList>
                <!-- <CommonNews></CommonNews> -->
                <!-- <router-view></router-view> -->
            </el-main>
        </el-container>
        <!-- 移动端 -->
        <el-container v-if="innerWidth < 1023">
            <MobileTab :asideData="asideData" :cityList="cityList" :equipmentList="equipmentList" :equipment_id="equipment_id" :supplierBrand="supplierBrand"  :brand_id="brand_id" @selectEquipment="selectEquipment" @selectBrand="selectBrand"  @menu-item-clicked="handleMenuItemClick" @selectCity="selectCity" @inputChange="inputChange"></MobileTab>
        </el-container>
        <supplierList v-if="innerWidth < 1023" :innerWidth="innerWidth"  :supplierList="supplierList" :recommendlist="recommendlist" ></supplierList>

    </div>
</template>

<script>
import { getlist,recommendList,swiperList,cityList  } from '../api/api';
import CommonAside from "../components/CommonAside.vue";
import CommonHeader from "../components/CommonHeader.vue";
// import CommonTag from "../components/CommonTag.vue";
import CommonTab from "../components/CommonTab.vue";
import supplierList from "../components/supplierList.vue";
import CommonFooter from "../components/CommonFooter.vue";
import CommonNews from "../components/CommonNews.vue";
import MobileTab from "../components/MobileTab.vue";

export default {
    data() {
        return {
            asideData: [],
            supplierList: [],
            equipmentList:[],
            supplierBrand:[],
            brand_id:0,
            equipment_id:0,
            recommendlist:[],
            swiperList:[],
            innerWidth: window.innerWidth,
            search:'',
            city_id:1965,
            cityList:'',//城市列表
        }
    },
    components: {
        CommonAside,
        CommonHeader,
        // CommonTag,
        CommonTab,
        supplierList,
        CommonFooter,
        CommonNews,
        MobileTab
    },
    computed: {
        isMobile() {
            return this.innerWidth < 768;
        }
    },
    methods: {
        async getlist() {
            const data = {
                page: 1,
                city_id: this.city_id,
                brand_id: this.brand_id,
                tag_id: 0,
                territory_id: this.equipment_id?this.equipment_id:0,
                token: "",
                wxapp_id: '10001',
                search:this.search
            }
            console.log(data);
            getlist(data).then(response => {
                this.asideData = response.data.data.supplier_territory_list
                this.supplierList=response.data.data.list.data
                this.supplierBrand=response.data.data.supplier_brand_list
                if (!this.equipment_id) {
                    this.equipment_id=response.data.data.supplier_territory_list[0].child[0].id
                }
                if (!this.brand_id) {
                    this.brand_id=response.data.data.supplier_brand_list[0].id
                }
                if (!this.equipmentList.length) {
                    this.equipmentList=response.data.data.supplier_territory_list[0].child
                }
            })
                .catch(error => {
                    console.error(error);
                });
        },
        async getrecommendList(){
            const data = {
                token: "",
                wxapp_id: '10001'
            }
            recommendList(data).then(response => {
                this.recommendlist=response.data.data.list.data
            }).catch(error => {
                    console.error(error);
            });
        },
        async getswiperList(){
            const data = {
                token: "",
                wxapp_id: '10001'
            }
            swiperList(data).then(response => {
                console.log(response);
                this.swiperList=response.data.data.lists
            }).catch(error => {
                    console.error(error);
            });
        },
        handleMenuItemClick(item) {
            console.log(item);
            this.equipment_id=item.child[0].id
            this.brand_id=0
            this.equipmentList=item.child
            this.getlist(item.child[0].id)
        },
        selectEquipment(e){
            this.equipment_id=e
            this.brand_id=0
            this.getlist() 
        },
        selectBrand(e){
            this.brand_id=e
            this.getlist()
        },
        updateInnerWidth() {
            this.innerWidth = window.innerWidth;
        },
        getAsideWidth() {
            if (this.innerWidth < 768) {
                return '100%';
            } else if (this.innerWidth < 1024) {
                return '200px';
            } else {
                return '250px';
            }
        },
        getCitylist(){
            const data = {
                token: "",
                wxapp_id: '10001'
            }
            cityList(data).then(response => {
               this.cityList=response.data.data.list
            }).catch(error => {
                    console.error(error);
            });
        },
        selectCity(e){
            this.city_id=e
            this.brand_id=''
            this.equipment_id=''
            this.getlist()
        },
        inputChange(e){
            this.search=e
            this.brand_id=''
            this.equipment_id=''
            this.getlist()
        },
        serach(e){
            this.search=e
            this.brand_id=''
            this.equipment_id=''
            this.getlist()
        }
    },
    created() {
        this.getlist()
        this.getswiperList()
        this.getrecommendList()
        this.getCitylist()
        window.addEventListener('resize', this.updateInnerWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateInnerWidth);
    }
}
</script>

<style>
.el-header {
    padding: 0;
}

@media (max-width: 767px) {
    .headimg{
        width: 100vw;
        height: 12em;
    }
}

/* 平板样式 */
@media (min-width: 768px) and (max-width: 1023px) {
    .headimg{
        width: 100vw;
        height: 18em;
    }
}

/* 桌面样式 */
@media (min-width: 1024px) {
    .headimg{
        width: 100vw;
        height: 22em;
    }
}
</style>